module.exports = __webpack_public_path__ + "media/images/reports/recommendation_letter1-8d2b7c35752f8c6b7b2be8b54cae9ef4.svg";